import {createSlice} from '@reduxjs/toolkit'
import {LimpiezaModel} from '../../models'

export const EmptyLimpiezaState: LimpiezaModel = {
  showPanel: false,
  tabs: [
    {
      id: 0,
      title: 'Inicio',
      showPanel: false,
      idToEdit: '',
      idToDelete: '',
      loadingTable: false,
      content: {
        headerPanel: '',
        detailPanel: '',
      },
      submenu: 'start',
      closable: false,
      reset: false,
      currentExternalTab: 0,
      typeAdmin: '',
      aditionalInformation: null,
      isCancel: false,
      detailRow: null,
    },
  ],
  menu: [],
  currentTab: 0,
  permissions: [],
}

export const limpiezaSlice = createSlice({
  name: 'hospitality',
  initialState: EmptyLimpiezaState,
  reducers: {
    addTabAction: (state, action) => {
      return {...state, tabs: [...state.tabs, action.payload]}
    },
    deleteTabAction: (state, action) => {
      return {...state, tabs: action.payload}
    },
    changeTabAction: (state, action) => {
      return {...state, currentTab: action.payload}
    },
    setCurrentTabItemAction: (state, action) => {
      return {
        ...state,
        tabs: state.tabs.map((tab, idx) =>
          idx === state.currentTab ? {...tab, ...action.payload} : tab,
        ),
      }
    },
    setMenuFromApi: (state, action) => {
      return {...state, menu: action.payload}
    },
    setPermissionsFromApi: (state, action) => {
      return {...state, permissions: action.payload}
    },
    resetCentral: () => {
      return EmptyLimpiezaState
    },
  },
})

export const {
  addTabAction,
  deleteTabAction,
  changeTabAction,
  setCurrentTabItemAction,
  resetCentral,
  setMenuFromApi,
  setPermissionsFromApi,
} = limpiezaSlice.actions

export default limpiezaSlice.reducer
